const isObjectLike = (value) => value !== null && typeof value === 'object';

const deepEqual = (valueA, valueB) => {
  if (Object.is(valueA, valueB)) {
    return true;
  }

  if (!isObjectLike(valueA) || !isObjectLike(valueB)) {
    return false;
  }

  const isArrayA = Array.isArray(valueA);
  const isArrayB = Array.isArray(valueB);
  if (isArrayA !== isArrayB) {
    return false;
  }

  if (isArrayA && isArrayB) {
    if (valueA.length !== valueB.length) {
      return false;
    }
    for (let i = 0; i < valueA.length; i += 1) {
      if (!deepEqual(valueA[i], valueB[i])) {
        return false;
      }
    }
    return true;
  }

  const keysA = Object.keys(valueA);
  const keysB = Object.keys(valueB);
  if (keysA.length !== keysB.length) {
    return false;
  }

  for (const key of keysA) {
    if (!Object.prototype.hasOwnProperty.call(valueB, key)) {
      return false;
    }
    if (!deepEqual(valueA[key], valueB[key])) {
      return false;
    }
  }

  return true;
};

export default deepEqual;
